import type { Shift } from "@ots-frontend/ots-data";
import { OtsBadge } from "../components/OtsBadge";
import { OtsCostingButton } from "../components/OtsCostingButton";
import { OtsTooltip } from "../components/OtsTooltip";
import type { ActivityShiftCost } from "./driver-activity-actions";

export type ActivityShiftCostCellProps = {
  shift: Shift;
  shiftCost: ActivityShiftCost;
};

/**
 * A closed shift's costing, at the end of its end row: the button that costs it (or previews the cost, for anyone
 * but an admin), which shows the costing running and celebrates when it is done, and a reminder when the figures
 * shown are an unsaved preview.
 */
export const ActivityShiftCostCell = ({ shift, shiftCost }: ActivityShiftCostCellProps) => {
  const state = shiftCost.stateOf(shift.id);
  const status = state?.status ?? "idle";
  return <>
    {state?.preview && status !== "running" && (
      <OtsTooltip density="compact" content="These figures were worked out but not saved; reload the day for the saved ones.">
        <span tabIndex={0} className="rounded outline-none focus-visible:ring-2 focus-visible:ring-[var(--ots-primary)]">
          <OtsBadge tone="warning" size="compact">Preview, not saved</OtsBadge>
        </span>
      </OtsTooltip>
    )}
    <OtsCostingButton
      label={shiftCost.preview ? "Preview cost" : "Cost shift"}
      status={status}
      progress={state?.progress}
      startedAt={state?.startedAt}
      error={state?.error}
      onClick={() => shiftCost.run(shift)}/>
  </>;
};
